var ExternalUrlConfigAction;
(function (ExternalUrlConfigAction) {
  ExternalUrlConfigAction["VIEW_DETAIL"] = "viewDetail";
  ExternalUrlConfigAction["SUBSTITUTION"] = "substitution";
})(ExternalUrlConfigAction || (ExternalUrlConfigAction = {}));
var ExternalUrl;
(function (ExternalUrl) {
  ExternalUrl["DEFAULT"] = "#";
})(ExternalUrl || (ExternalUrl = {}));

const generateExternalURL = (action, externalUrlConfig, product) => {
  var _a;
  if (!externalUrlConfig)
    return ExternalUrl.DEFAULT;
  const actionUrl = (_a = externalUrlConfig[action]) !== null && _a !== void 0 ? _a : [];
  const copyOfUrl = [...actionUrl];
  if (!copyOfUrl.length)
    return ExternalUrl.DEFAULT;
  copyOfUrl.forEach((urlFragment, index) => {
    const keyName = urlFragment.replace('${', '').replace('}', '');
    if (!(product === null || product === void 0 ? void 0 : product.hasOwnProperty(keyName)))
      return;
    copyOfUrl[index] = product[keyName];
  });
  return copyOfUrl.join('');
};

export { ExternalUrlConfigAction as E, generateExternalURL as g };
